var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGirlImg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 480,
    height: 870,
    viewBox: "0 0 480 870",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2595",
    "data-name": "Rectangle 2595",
    width: 480,
    height: 870,
    transform: "translate(230 210)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2583",
    "data-name": "Rectangle 2583",
    width: 433.557,
    height: 1096.618,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(-230 -210)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6696",
    "data-name": "Group 6696",
    transform: "translate(-46 286.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6695",
    "data-name": "Group 6695",
    transform: "translate(289 -22.511)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6694",
    "data-name": "Group 6694",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M149,39.489a.835.835,0,1,1,1.67.027c0,.183-.562,63.973-56.213,71.094a.836.836,0,0,1-.211-1.658c54.2-6.935,54.75-69.283,54.753-69.463",
    transform: "translate(192.049 79.412)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M167,6.279c70.367,31.188,74.994,159.387-.321,178.582-69.479,17.709-80.029-7.515-80.029-7.515l-7.509-57.6-4,.449c-4.727-14.206-8.783-29.545-12.438-43.36C45.313,11.055,124.465-12.575,167,6.279",
    transform: "translate(123.73 0)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M9.334,55.038h0a5.935,5.935,0,0,1,5.918,5.918V75.474a5.918,5.918,0,1,1-11.836,0V60.956a5.935,5.935,0,0,1,5.918-5.918",
    transform: "translate(7.016 113.033)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M104.753,36.979h0A24.311,24.311,0,0,1,128.993,61.22v78.35a24.241,24.241,0,0,1-48.481,0V61.22a24.311,24.311,0,0,1,24.241-24.241",
    transform: "translate(165.35 75.945)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M72.309,121.056,55.2,104.227s-8.044-23.81-8.6-25.615S36.525,67.24,34.027,64.929s-12.716-3.884-14.841-4.81-4.071,4.993-1.527,8.645S25.935,73.3,25.935,73.3l4.391,6.843L15.161,71.449s2.822-4.208.324-8.324c0,0-.971-1.014-3.561-.922s-8.413,3.515-9.479,3.976A4.6,4.6,0,0,0,1.2,73.3c2.864,3.7,9.247,9.247,9.247,9.247L8.5,105.015l.553,7.491s4.345,4.345,5.827,5.362,20.991,6.382,20.991,6.382L52.514,141.08s19.745-20.072,19.794-20.023",
    transform: "translate(0.001 123.27)",
    fill: "#f2ba95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M39.313,80.915l-4.629-4.556L12.819,94.013l12.267,12.4s10.334-10.5,16.066-16.295c-.635-2.437-1.3-6-1.838-9.2",
    transform: "translate(26.327 156.821)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M23.844,72.162,9.2,63.764l-5.607,4.9,7.353,14.069L2.9,102.36l.18,2.461s3.118,3.121,4.971,4.694l22.3-11.345s.424-9.851,6.474-15.165c0,0,.647-.37.092-1.2s-1.539-.55-7.592,1.79-5.491-11.43-5.491-11.43",
    transform: "translate(5.966 130.954)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M29.2,75.357a61.763,61.763,0,0,0-5.741-4.312C20.317,69.058,10.744,65.592,8.8,65.173S3.164,67.21,2.563,69.43s.507,8.645.507,8.645S.434,84.644,2.654,89.588c0,0-.742,5.084-.879,6.843s3.652,5.591,3.652,5.591,4.162-.321,5.365-3.7c0,0,1.432-.232,1.615-1.109,4.626.638,13.079,3.13,12.716-4.116,6.59,1.869,8.028-4.4,5.411-6.517a34.876,34.876,0,0,0-3.469-2.5c5.539,0,5.985-5.527,2.135-8.728",
    transform: "translate(3.624 133.753)",
    fill: "#f2ba95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M3.028,92.436a.837.837,0,1,1-.818-1.46l5.039-2.822.037-.018a5.765,5.765,0,0,1,3.777-.58c1.912.394,14.38,6.9,14.414,6.923A.835.835,0,1,1,24.7,95.96c-.034-.018-12.285-6.416-13.977-6.764a3.979,3.979,0,0,0-2.6.385l-.058.037ZM27.491,85.5a.836.836,0,0,1-.919,1.4l-4.422-2.916c-.653-.293-8.254-3.7-10.9-4.718a6.548,6.548,0,0,0-3.628-.214,11.006,11.006,0,0,0-4.1,1.823.837.837,0,1,1-.968-1.365,12.723,12.723,0,0,1,4.739-2.1,8.173,8.173,0,0,1,4.55.287c2.782,1.066,11.033,4.776,11.058,4.785v0a.537.537,0,0,1,.107.061Zm-.678-12.9a.839.839,0,1,1-.29-1.652c.015,0,5.118-1.124,10.96,2.77a.836.836,0,0,1-.931,1.389c-5.249-3.5-9.726-2.51-9.738-2.507m-4.6-6.834a.838.838,0,1,1,.131-1.67l4.107.327a.838.838,0,1,1-.131,1.67Z",
    transform: "translate(3.66 131.634)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M9.431,101.993a.836.836,0,1,1-.962-1.368,4.465,4.465,0,0,0,.956-.907,3.914,3.914,0,0,0,.6-1.112.836.836,0,0,1,.629-.541v0s.895-.162.962-.458a.832.832,0,0,1,.959-.654c.611.085,1.252.2,1.921.308a28.675,28.675,0,0,0,5.839.6c2.318-.116,4.132-1.06,3.979-4.156a.836.836,0,0,1,.794-.876.855.855,0,0,1,.266.031,5.2,5.2,0,0,0,4.055-.174,3.029,3.029,0,0,0,1.157-1.218,3.371,3.371,0,0,0,.37-1.591,2.718,2.718,0,0,0-.922-2.08,35.339,35.339,0,0,0-3.371-2.431.835.835,0,0,1-.287-1.148.826.826,0,0,1,.715-.4v-.006a4.626,4.626,0,0,0,2.6-.666l.046-.034a2.643,2.643,0,0,0,1.041-1.463,3.789,3.789,0,0,0-.043-2.083,6.242,6.242,0,0,0-2.046-3v0c-.76-.629-1.713-1.4-2.684-2.147-.989-.757-2.031-1.512-2.968-2.1a45.748,45.748,0,0,0-6.224-2.9,77.981,77.981,0,0,0-8.166-2.861A4.608,4.608,0,0,0,5.644,67.59,5.422,5.422,0,0,0,3.4,70.207a.841.841,0,0,1-1.625-.434A7.125,7.125,0,0,1,4.7,66.207,6.213,6.213,0,0,1,9,64.915a79.729,79.729,0,0,1,8.441,2.947A46.906,46.906,0,0,1,23.936,70.9c.986.626,2.07,1.408,3.09,2.186,1.044.8,2,1.573,2.736,2.186h0v0A7.9,7.9,0,0,1,32.355,79.1a5.386,5.386,0,0,1,.037,3,4.343,4.343,0,0,1-1.692,2.37l-.067.049a5.148,5.148,0,0,1-1.295.626c.519.373,1.118.825,1.75,1.338V86.5a4.385,4.385,0,0,1,1.542,3.344,5,5,0,0,1-.553,2.391,4.633,4.633,0,0,1-1.811,1.9,6.232,6.232,0,0,1-4.284.583c-.229,3.539-2.6,4.669-5.564,4.816a29.74,29.74,0,0,1-6.2-.617c-.461-.079-.907-.156-1.316-.22a3.026,3.026,0,0,1-1.466.907,5.578,5.578,0,0,1-.684,1.139,6.138,6.138,0,0,1-1.319,1.255",
    transform: "translate(3.596 133.193)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M138.546,339.626l-4.211,3.658s3.677-.064,3.677,5.039-18.906,49.223-18.906,49.223-.07,1.567,1.832,1.567h20s2.513.168,2.513-3.46,4.126-54.109,4.126-54.109Z",
    transform: "translate(244.612 697.502)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M120.6,383.593l-10.117,13.513s-5.4,4.428-2.455,10.126,4.91,8.859,4.91,8.859a12.8,12.8,0,0,0,10.56,5.179h19.519c5.155,0,21.721-.434,22.066-13.617s1.844-38.584,1.844-38.584.3-3.121,2.177-3.555,4.544-1,3.808-4.8-8.654-28.476-8.654-28.476a4.793,4.793,0,0,0-4.471-3.368c-3.756-.324-10.016,2-10.016,2Z",
    transform: "translate(220.046 675.348)",
    fill: "#26377f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M151.621,410.86c0-3.387,3.869-43.748,2.956-52.686a21.793,21.793,0,0,0-.727-3.887l-1.109-5.43c1.7-9.546,3.5-19.5,5.368-29.75H125.059c-.018,14.27-.333,26.445-1.255,35.9-.5,5.13-9.949,47.858-9.946,47.858s-2.657,9.711-3.142,11.452a2.294,2.294,0,0,0,.428,2.47c5.814,4.8,21.321,3.2,28.849,1.411s11.629-3.951,11.629-7.341",
    transform: "translate(227.091 655.361)",
    fill: "#f2ba95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M110.38,356.113l-.492-3.322,2.229-.571s.654,1.2,2.22.36,2.028-2.373,4.483-2.373h21.022c4.422,0,4.663,2.678,8.776,1.8s-.058,5.289-.058,5.289-17.189,2.11-17.739,2.217-20.442-3.4-20.442-3.4",
    transform: "translate(225.681 719.233)",
    fill: "#26377f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    d: "M94.677,339.626l-4.211,3.658s3.674-.064,3.674,5.039-18.9,49.223-18.9,49.223-.07,1.567,1.832,1.567h20s2.513.168,2.513-3.46,4.129-54.109,4.129-54.109Z",
    transform: "translate(154.517 697.502)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2265",
    "data-name": "Path 2265",
    d: "M76.726,383.593,66.609,397.106s-5.4,4.428-2.455,10.126,4.91,8.859,4.91,8.859a12.794,12.794,0,0,0,10.557,5.179H99.143c5.155,0,21.721-.434,22.063-13.617s1.847-38.584,1.847-38.584.3-3.121,2.177-3.555,4.544-1,3.8-4.8-8.651-28.476-8.651-28.476a4.793,4.793,0,0,0-4.471-3.368c-3.756-.324-10.016,2-10.016,2Z",
    transform: "translate(129.951 675.348)",
    fill: "#26377f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    "data-name": "Path 2266",
    d: "M107.752,410.86c0-3.387,3.869-43.748,2.956-52.686a21.786,21.786,0,0,0-.727-3.887l-1.112-5.43c1.707-9.546,3.506-19.5,5.375-29.75H81.193c-.018,14.27-.336,26.445-1.258,35.9-.5,5.13-9.949,47.858-9.946,47.858s-2.657,9.711-3.142,11.452a2.294,2.294,0,0,0,.428,2.47c5.814,4.8,21.324,3.2,28.849,1.411s11.629-3.951,11.629-7.341",
    transform: "translate(136.996 655.361)",
    fill: "#f2ba95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2267",
    "data-name": "Path 2267",
    d: "M66.51,356.113l-.492-3.322,2.229-.571s.653,1.2,2.22.36,2.028-2.373,4.483-2.373H95.972c4.422,0,4.663,2.678,8.779,1.8s-.061,5.289-.061,5.289-17.186,2.11-17.739,2.217-20.442-3.4-20.442-3.4",
    transform: "translate(135.583 719.233)",
    fill: "#26377f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    d: "M63.5,281.468s28.849,70.276,135.372-5.918S142.652,151.269,112.319,181.6,63.5,281.468,63.5,281.468",
    transform: "translate(130.41 354.06)",
    fill: "#0094da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    d: "M67.262,203.56,54.085,226.124,78.836,467.653s-7.164,7.766-.553,15.165c0,0-2.754,8.508,2.2,11.836L98.123,730.268a6.446,6.446,0,0,0,2.758,4.437c2.547,1.756,17.29,3.142,25.144,2.773s19.7-8.694,21.492-11.467c0,0,1.38-2.034.831-9.433s-5.372-227.845-5.372-227.845,5.375-6.477,0-16.646c0,0,2.895-2.959.415-7.582l11.8-233.214L125.7,139.822Z",
    transform: "translate(111.076 287.157)",
    fill: "#26377f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    d: "M63.493,203.56,55.92,216.529l2.275,86.5,9.18,89.581,75.143,14.661,2.339-46.237a180.931,180.931,0,0,1-19.794-49.1s-1.105-54.005-.183-63.808,5.365-9.06,5.365-9.06l18.7,41.112,2.473-48.887-29.493-91.469Z",
    transform: "translate(114.845 287.157)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    "data-name": "Path 2271",
    d: "M109.126,178.162l-12.362-38.34L68.172,171.01c13.027,2.394,27.026,4.868,40.954,7.152",
    transform: "translate(140.007 287.157)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    "data-name": "Path 2272",
    d: "M76.743,155.294c29.307,113.138,45.772,188.99,64.138,305.829,0,0-3.582,7.4,3.032,15.9,0,0-1.79,6.1,1.377,9.433L184,737.974a19.5,19.5,0,0,0,10.887,5.179c6.886.925,17.083,1.295,21.767-1.112s17.086-11.65,17.086-11.65a2.722,2.722,0,0,0,.724-2.266c-.2-1.386-24.558-262.062-24.558-262.062s2.483-12.023-2.477-16.463c0,0,3.307-7.582-.553-12.019,0,0,2.208-13.128,1.655-23.117s-10.471-181.612-11.021-186.421,2.477-32.11,2.477-32.11l-32.507-60.916Z",
    transform: "translate(157.61 277.289)",
    fill: "#26377f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    d: "M147.092,234.774l-1.838-31.628-26.5,8.328-3.7,15.534-9.512,25.755Z",
    transform: "translate(216.764 417.21)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    d: "M76.743,149.638c2.813,10.862,5.509,21.379,8.1,31.625,37.552,6.306,75.781,11.537,94,10.419,35.231-2.165-16.56-42.285-49-53.911Z",
    transform: "translate(157.61 282.945)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M119.352,70.213c0,4.523,3.912,8.926,9.595,11.583l2.474-3.463,2.5-.183,6.1,2.263,3.145,3.7-.034.092c9.479-.919,19.382-6.987,24.7-22.03l30.085,9.146-27,221.558L150.2,299.537s-35.961,6.126-58.812,0l-9.433-3.142-6.288-78.6-12.206-23.3s-4.071-3.884-.186-17.571,15.165-42.539,15.165-42.539L84.729,79.64l34.623-13.317Z",
    transform: "translate(126.51 127.693)",
    fill: "#4bc9ef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M156.064,294.524l-5.86,1.884s-35.961,6.123-58.812,0l-9.433-3.142-6.288-78.6-12.206-23.3s-4.071-3.884-.186-17.568,15.165-42.539,15.165-42.539l6.288-54.744,33.3-12.807c-4.416,24.885-15.644,85.685-16.347,94.406-.834,10.355,4.81,9.341,4.81,9.341h49.006l-3.79,36.245H113.987c-8.138,0-7.582,5.918-7.582,5.918s4.071,49.009,4.44,60.476,7.03,12.762,7.03,12.762l29.218,7.21s4.11,1.96,8.972,4.465",
    transform: "translate(126.51 130.825)",
    fill: "#4bc9ef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M173.6,68.011S161.013,73.92,155.647,85.2s-34.953,76.383-34.953,76.383L48.934,91.674s-2.22-1.851-5.362.739-32.18,36.062-32.18,36.062-2.22,3.7,1.109,8.877,85.444,90.989,85.444,90.989,19.6,13.317,39.576-2.59a153.354,153.354,0,0,0,31.069-33.289Z",
    transform: "translate(21.906 139.677)",
    fill: "#0094da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    d: "M50.285,172.325a38.933,38.933,0,0,0,5.869-3.884,153.45,153.45,0,0,0,31.069-33.289l.956-23.7L82.85,95.917l-12.713,15.29Z",
    transform: "translate(103.272 196.988)",
    fill: "#0094da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M142.066,68.875a35.313,35.313,0,0,1,13.183,15.03c4.807,10.355,52.8,125.27,52.8,125.27s7.4,31.072-7.027,46.606-68.059,70.279-68.059,70.279l-24.079-68.654,45.348-31.215s-2.034-4.993,2.959-6.288c0,0-2.59-2.776-.369-5.365L126.061,160.86s-22.408-77.143,16-91.985",
    transform: "translate(223.613 141.451)",
    fill: "#0094da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M191.171,128.982a26.37,26.37,0,0,1-2.635,3.356c-14.426,15.534-68.059,70.276-68.059,70.276l-5.518-15.733,15.965-24.973Z",
    transform: "translate(236.095 264.895)",
    fill: "#0094da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M136.213,196.523l-2.513,2.571a4.334,4.334,0,0,1-1.527-.321l-23.144-65.985a25.7,25.7,0,0,1,1.447-2.593c45.6-.883,32.263,35.112,25.737,66.327",
    transform: "translate(223.917 267.355)",
    fill: "#abd3ec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M113.568,130.33c17.574,2.2,22.888,12.053,23.1,25.041l-13.357,10.05.073,4.7s-4.22-8.328-3.307-8.795-7.213-3.7-7.769-5.549,1.261-25.413,1.264-25.45",
    transform: "translate(230.426 267.663)",
    fill: "#d77174",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M67.376,149.017s37.353,14.8,79.156,2.959-.745-13.687-.745-13.687-25.151,9.25-58.626,3.145Z",
    transform: "translate(138.372 284.009)",
    fill: "#4bc9ef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M133.937,62.057l-44.2,130.01s-4.071,13.314-3.329,22.564,6.657,25.151,6.657,25.151l1.109,12.945s-2.587,2.959-.739,6.288c0,0-4.81,4.254-1.295,9.064,0,0-1.478,19.6-.739,29.218s53.63,245.23,53.63,245.23,73.238-65.1,79.895-82.115-3.7-45.864-20.714-89.511-51.046-105.045-51.046-105.045a5.977,5.977,0,0,0-.37-7.4s1.295-4.254-.925-6.1L172.4,174.862s-14.325-66.834,16-91.988Z",
    transform: "translate(177.275 127.449)",
    fill: "#0094da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M151.206,191.188c-7.876-17.315-16.728-35-24.094-49.226-6.077-3.017-10.535-5.106-10.535-5.106l-9.861,16.362Z",
    transform: "translate(219.166 281.066)",
    fill: "#0094da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "M86.617,151.67c.165.831.354,1.677.559,2.529,8.315.189,39.277-.165,47.556-.165,9.8,0,11.28,8.508,11.28,8.508l5.246,21.431,20.527-77.492s-.922-4.3-1.8-11.128l-29.334,42.96H119.377c-10.532,0-6.84-9.247-6.84-9.247L116.3,112.9,93.671,129.808s-4.419,15.76-7.054,21.862",
    transform: "translate(177.888 195.83)",
    fill: "#0094da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M144.01,66.585,118.447,184.942s-1.478,11.836,1.851,18.493,11.467,19.6,11.467,19.6l.739,7.769a3.281,3.281,0,0,1,.553,4.254s2.776,2.773.37,7.213l3.515,43.644s.922,6.843-.186,18.31-.553,145.73.186,163.485,16.276,60.659,30.33,88.772c0,0-42.905-4.44-71.757-8.138s-45.125-15.534-47.345-22.934,1.478-81.373,8.135-110.225S94.771,273.894,94.771,273.894s-2.773-5.365,1.481-8.508c0,0-3.515-4.623-.742-7.952l-1.667-29.777s-17.385-25.523-19.232-36.248,16.27-61.4,17.012-65.472,6.288-46.606,6.288-46.606L144.01,62.5Z",
    transform: "translate(97.599 128.356)",
    fill: "#0094da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M100.031,107.7c-.15,4.049.031,10.331,2.138,14.542,3.329,6.657,11.467,19.6,11.467,19.6H82.787a7.848,7.848,0,0,0-7.069,4.62s-17.388-25.523-19.235-36.251a27.5,27.5,0,0,1,.55-8.187c.027.134,1.115,5.207,9.662,5.552,4.709.189,20.182.174,33.338.119",
    transform: "translate(115.728 209.547)",
    fill: "#0094da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    d: "M123.722,66.026l6.535-4.739,22.378,7.121,16.09,37.17S108.438,192.866,101.778,208.4s-8.712,32.965-8.712,32.965l-.217-.589c-1.066-2.953-5.787-16.371-6.44-24.564-.742-9.247,3.329-22.561,3.329-22.561L132.245,68.619Z",
    transform: "translate(177.275 125.867)",
    fill: "#0094da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    d: "M74.078,73.533,66.853,88.46l.183,93.4S68.252,207.311,91.5,222.14c-1.9-3.048-7.842-12.578-10.9-18.7s-1.851-18.5-1.851-18.5L104.142,67.362l3.9-1.5L104.31,62.5Z",
    transform: "translate(137.298 128.358)",
    fill: "#0094da",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    d: "M113.635,128.794l13.29,2.782a6.631,6.631,0,0,1,4.968,3.591c1.38,3.155,1.17,7.986,1.17,7.986a11.123,11.123,0,0,1,3.912,11.806s3.515,5.036,1.386,9.937c0,0,2.544,2.684,1.893,5.689a100.086,100.086,0,0,1-3.7,10.45,8.993,8.993,0,0,1-4.947,2.727c-3.371.739-3.878-5.781-2.681-7.815,0,0-5.268,3.237-8.786,1.9s-2.376-6.868-.654-9.051c0,0-7.753,3.64-10.416.983s-2.66-7.607.208-9.824c0,0-3.979-2.312-3.7-5.362s1.414-6.205,8.786-8.508l3.365-6.184Z",
    transform: "translate(216.809 264.509)",
    fill: "#f2ba95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M127.323,172.466a.837.837,0,0,1-.65-1.542l4.071-1.719a8.456,8.456,0,0,0,1.823-1.848c1.038-1.389,3.066-6.975,3.072-6.99a.836.836,0,0,1,1.579.55c-.006.018-2.138,5.872-3.313,7.442a9.637,9.637,0,0,1-2.284,2.278l0,0a.98.98,0,0,1-.137.073Zm-10.758-36.483a.835.835,0,0,1-1.527-.675c0-.009,1.322-2.968,6.507-4.413a.836.836,0,1,1,.446,1.612c-4.428,1.234-5.423,3.469-5.426,3.475m-9.005,20.524a.837.837,0,0,1-.428-1.618l13.687-3.643.009,0a4.488,4.488,0,0,0,2.874-2.254c1.133-2.266,6.718-10.532,6.737-10.557a.834.834,0,1,1,1.38.937c-.015.024-5.536,8.193-6.624,10.364a6.175,6.175,0,0,1-3.961,3.133Zm10.294,8.813,8.282-3.2.089-.04a10.749,10.749,0,0,0,4.04-3.387c1.426-2.083,5.442-7.476,5.451-7.491a.837.837,0,0,0-1.35-.989c-.012.012-4.028,5.408-5.485,7.537a9.1,9.1,0,0,1-3.356,2.812l-8.273,3.2a.836.836,0,0,0,.6,1.56m8.37-3.243-.015.006Z",
    transform: "translate(218.741 268.762)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M147.844,64.734a1.044,1.044,0,0,1,1.918-.828l16.09,37.17a1.039,1.039,0,0,1-.1,1l0,0c-.174.25-60.229,87.206-66.846,102.639-6.6,15.394-8.63,32.626-8.636,32.675a1.047,1.047,0,0,1-2.08-.238c.006-.052,2.073-17.58,8.792-33.255,6.425-14.988,62-95.683,66.721-102.532Z",
    transform: "translate(181.11 129.954)",
    fill: "#abd3ec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M73.84,66.363a1.046,1.046,0,1,1,1.884.91L68.6,81.986l.183,93.093c0,.073,1.188,24.928,23.981,39.46a1.045,1.045,0,0,1-1.124,1.762C67.937,201.183,66.7,175.269,66.7,175.2v-.058l-.183-93.331a1.029,1.029,0,0,1,.1-.516Z",
    transform: "translate(136.596 135.076)",
    fill: "#abd3ec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M118.51,161.351a1.046,1.046,0,0,1-2.049.424c-.04-.192-14.459-67.448,16.362-93a1.046,1.046,0,1,1,1.335,1.612c-29.838,24.747-15.687,90.778-15.647,90.968",
    transform: "translate(232.19 140.746)",
    fill: "#abd3ec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M68.611,202.781a1.043,1.043,0,0,1-1.793,1.066c-2.351-3.948-4.77-8.254-6.7-12.218a44.3,44.3,0,0,1-3.967-10.661c-1.435-8.324,8.535-39.176,13.87-55.694,1.735-5.372,2.977-9.21,3.145-10.138.736-4.046,6.263-46.435,6.278-46.557a1.045,1.045,0,0,1,2.073.269c-.015.122-5.552,42.569-6.3,46.658-.2,1.084-1.454,4.971-3.209,10.407-5.28,16.347-15.147,46.881-13.8,54.7A42.412,42.412,0,0,0,62,190.713c1.939,3.982,4.321,8.218,6.611,12.068",
    transform: "translate(115.028 138.975)",
    fill: "#abd3ec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M83.093,65,97.663,76.83l-8.6,9.708L79.255,66.481l3.839-3.661Z",
    transform: "translate(162.769 129.014)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M85.283,80.313l33.912-15.974V61.123l6.654,5.237L97.07,92.748Z",
    transform: "translate(175.149 125.531)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M8.47,61.665S7.5,60.648,4.909,60.74a6.359,6.359,0,0,0-1.493.284v2.751a5.944,5.944,0,0,0,4.953,5.839c.611-1.121,2.153-4.565.1-7.949",
    transform: "translate(7.016 124.732)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M15.252,60.956a5.918,5.918,0,1,0-11.836,0v7.213H15.252Z",
    transform: "translate(7.016 113.033)",
    fill: "#e6344c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M124.645,127.5a.838.838,0,0,1-.7-1.521c.037-.015,12.065-5.83,26.946,1.371a.837.837,0,0,1-.727,1.509c-14.157-6.853-25.483-1.374-25.517-1.359m3.045-6.333c.018-.009,6.321-3.9,15.308-1.319a.837.837,0,1,0,.458-1.609,21.934,21.934,0,0,0-16.64,1.5.837.837,0,0,0,.873,1.429",
    transform: "translate(253.548 240.899)",
    fill: "#abd3ec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M46.643,100.077a1.044,1.044,0,1,1,1.512-1.441l8.663,9.121A1.045,1.045,0,1,1,55.3,109.2Z",
    transform: "translate(95.2 201.904)",
    fill: "#abd3ec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M77.5,347.776a80.548,80.548,0,0,0,27.2-5.008c.174-3.035.308-5.891.385-8.386-3.588,1.887-7.469,3.371-10.679,3.521a97.075,97.075,0,0,1-11.281-.293A78.586,78.586,0,0,1,71.9,336.08c-.73,3.561-1.567,7.534-2.416,11.5,2.571.168,5.252.244,8.019.2",
    transform: "translate(142.696 686.732)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M115.7,337.368c-.583,2.895-1.276,6.217-2.006,9.674a78.361,78.361,0,0,0,9.4.736,68.2,68.2,0,0,0,24.958-4.15c.232-4.776.333-8.85.2-11.387A81.992,81.992,0,0,1,140.774,337c-2.858,1.466-7.756,1.9-12.713,1.808a81.334,81.334,0,0,1-9.06-.7,19.646,19.646,0,0,1-3.3-.739",
    transform: "translate(233.495 682.335)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M67.455,44.251a144.865,144.865,0,0,1,2.819,33.985c-1.3,50.127,6.511,61.554,22.048,69.808s38.419-3.915,35.374-27.416c-2.452-18.933-37.958-28.861-42.438-68.837-7.219,5.045-13.641-.825-17.8-7.54",
    transform: "translate(138.535 90.88)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M106.6,38.343s4.208-6.144,7.671-6.349,8.822,6.456,9.192,12.059-3.161,25.789-15.51,20.213S106.6,38.343,106.6,38.343",
    transform: "translate(209.658 65.698)",
    fill: "#f2ba95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M102.645,41.661a1.261,1.261,0,0,0-.027,1.487.693.693,0,0,0,1.066.015s5.637,16.551,7.753,13.513,4.376-6,4.779-10.474-4.043-7.854-2.828-9.192c1.157-1.276,2.831.186,2.984.327l.006.006.006,0a11.513,11.513,0,0,1,2.122,2.935.693.693,0,0,0,1.133.238,1.3,1.3,0,0,0,.3-1.469c-.009-.018-2.938-6.181-7.647-5.243-4.5.895-9.628,7.836-9.644,7.854",
    transform: "translate(210.278 69.232)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M78.541,41.193s-5.891-4.556-9.25-3.689-6.416,8.853-5.048,14.3,10.92,23.575,20.964,14.478-6.666-25.086-6.666-25.086",
    transform: "translate(131.253 76.797)",
    fill: "#f2ba95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M82.041,43.5a1.262,1.262,0,0,1,.482,1.4.692.692,0,0,1-1.008.345s-.287,17.483-3.234,15.238-6.007-4.367-7.763-8.5,1.435-8.712-.131-9.613c-1.49-.858-2.635,1.047-2.739,1.225l-.006.009v0l0,0a11.533,11.533,0,0,0-1.118,3.445.7.7,0,0,1-1,.574,1.291,1.291,0,0,1-.733-1.31c0-.018.9-6.782,5.671-7.335,4.556-.528,11.564,4.5,11.586,4.516",
    transform: "translate(133.027 79.987)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M116.741,12.039c70.523-9.439,68.318,46.881,68.679,91.972.15,18.979-8.5,31.484-8.5,31.484s-17.241,20.362-23.55,25.035a33.881,33.881,0,0,1-28.479,4.232c-7.4-2.632-29.817-17.1-29.817-17.1s-11.91-9.451-17.287-27.652C65.013,76.766,46.52,23.524,116.741,12.039",
    transform: "translate(134.814 22.575)",
    fill: "#f2ba95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M68.217,71.248c-.718-3.014-1.365-6.019-1.921-9.005,9.231-15.318,58.287-41.366,72.334-41.769,19.235-.556,37.359,9.986,39.576,12.759s3.429,18.936,3.429,18.936-17.669.3-40.047-15.791c0,0-23.859,39.949-65.469,36.617a23.114,23.114,0,0,1-7.9-1.747",
    transform: "translate(136.154 42.003)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M88.262,56.842a1.248,1.248,0,1,1,.058-2.495A30.63,30.63,0,0,0,96.43,53.08a1.249,1.249,0,0,1,.7,2.4,33.656,33.656,0,0,1-8.868,1.365",
    transform: "translate(178.763 108.909)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M98.641,38.175h0a5.932,5.932,0,0,1,3.46.507,3.155,3.155,0,0,0,1.234-2.541,1.04,1.04,0,1,1,2.08-.058,4.937,4.937,0,0,1-1.133,3.332,1.617,1.617,0,0,0,1.163-.928,1.044,1.044,0,0,1,1.89.889,3.528,3.528,0,0,1-2.437,2.052,5.967,5.967,0,0,1,.547,1.725l.91,5.872a5.962,5.962,0,0,1-11.784,1.823l-.91-5.869a5.976,5.976,0,0,1,4.978-6.8",
    transform: "translate(192.215 72.028)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M96.842,37.957a4.865,4.865,0,0,1-2.916.226,5.446,5.446,0,0,1-3-3.063c-.012-.541.867.183,3.313-1.423,2.406-1.579,11.537-5.921,19.211-.177,1.325.992.6,2.037-.907,1.783a18.84,18.84,0,0,0-15.7,2.654",
    transform: "translate(186.734 62.917)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M91.254,41.956a4.858,4.858,0,0,0,2.9-.4,5.448,5.448,0,0,0,2.281-3.628c-.1-.534-.806.363-3.539-.69-2.684-1.032-12.529-3.341-18.811,3.9-1.081,1.249-.156,2.116,1.264,1.548a18.853,18.853,0,0,1,15.907-.736",
    transform: "translate(151.176 74.055)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M91.691,49.321c.559-.681-.369-3.106-1.145-4.709-.586-1.215-1-1.783-1.365-1.673-.376-.082-.705.519-1.115,1.774-.537,1.658-1.112,4.144-.458,4.776.864.837,3.344.736,4.083-.168",
    transform: "translate(179.325 88.158)",
    fill: "#f9d4c8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M89.788,40.755a1.083,1.083,0,0,0-1.985.867c.791,1.82,5.347,12.172,5.262,13.177-.1.66-1.2,1.695-1.695,2.092a6.914,6.914,0,0,1-2.959,1.432,1.085,1.085,0,1,0,.4,2.132,9.1,9.1,0,0,0,3.915-1.869,6.861,6.861,0,0,0,2.483-3.463c.214-1.4-4.468-12.368-5.423-14.368",
    transform: "translate(179.759 82.368)",
    fill: "#ee8b83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M96.712,59.538l2.571-.4,3.973-.617c5.488-.852,6.391-8.6,6.391-8.6s-.275-1.215-1.875-.968l-9.83,1.524-2.571.4L85.538,52.4c-1.6.247-1.493,1.49-1.493,1.49S87.251,61,92.739,60.154Z",
    transform: "translate(172.603 100.475)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M92.387,46.073a4.866,4.866,0,0,0,2.88-.522,5.425,5.425,0,0,0,2.122-3.723c-.122-.528-.791.4-3.564-.537-2.284-.767-9.61-2.211-15.44,1.738a3.078,3.078,0,0,1-1.814-1.878,1.041,1.041,0,0,0-1.976.66,4.959,4.959,0,0,0,2.031,2.629l-.134.125a1.6,1.6,0,0,1-1.1-.489,1.044,1.044,0,1,0-1.469,1.484,4.074,4.074,0,0,0,1.047.763c-.632,1.1.281,1.741,1.554,1.163a18.856,18.856,0,0,1,15.861-1.414",
    transform: "translate(151.185 82.95)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M65.074,84.527s39.076,20.506,79.657-32.486c0,0,20.222,25.38,48,22.842L181.9,44.034a25.586,25.586,0,0,1-.544-3.356C171.146-7.149,63.107,1.3,66.277,56.6a26.6,26.6,0,0,1,.3,3.185Z",
    transform: "translate(133.645 19.361)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M181.878,50.67l-1.105-9.87C174.888-11.7,57.694-2.893,65.451,56.551l.8,6.111C63.82,6.635,176.121-.694,181.878,50.67",
    transform: "translate(133.662 12.723)",
    fill: "#e7477b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M79.447,35.712s7.732,17.394-2.422,31.444l-7.7-16.139s-2.44-2.965-4.571-1l1.7-5.707L67.61,32.475Z",
    transform: "translate(132.983 66.695)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M102.481,29.265S99.965,48.039,110.24,54.7l2.782-12.67s1.866-5.2,5.741-1.768l-.653-9.005Z",
    transform: "translate(209.91 60.103)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M133.024,23.494a.836.836,0,1,1,1.585.531C134.567,24.154,119.6,69.8,69.174,63.8a.838.838,0,0,1,.2-1.664c49.07,5.836,63.612-38.517,63.655-38.642",
    transform: "translate(140.547 47.077)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M70.554,57.118a.837.837,0,1,1,1.625.406c-.037.153-13.54,52.936,16.179,67.613a.837.837,0,0,1-.739,1.5c-30.944-15.281-17.1-69.366-17.064-69.521",
    transform: "translate(138.493 116.001)",
    fill: "#262262",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "M107.279,43.958a1.388,1.388,0,1,0-1.386-1.386,1.389,1.389,0,0,0,1.386,1.386",
    transform: "translate(217.476 84.577)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M107.279,47.836a1.388,1.388,0,1,0-1.386-1.386,1.389,1.389,0,0,0,1.386,1.386",
    transform: "translate(217.476 92.541)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M107.279,51.561a1.388,1.388,0,1,0-1.386-1.386,1.389,1.389,0,0,0,1.386,1.386",
    transform: "translate(217.476 100.191)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M108.4,52.527a3.052,3.052,0,1,0-3.051-3.051,3.057,3.057,0,0,0,3.051,3.051",
    transform: "translate(216.357 95.341)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M106.242,41.853a.319.319,0,1,1,.638,0V65.07a.319.319,0,1,1-.638,0Z",
    transform: "translate(218.193 85.296)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M69.494,49.088A1.388,1.388,0,1,0,68.108,47.7a1.389,1.389,0,0,0,1.386,1.386",
    transform: "translate(139.876 95.113)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M69.494,52.966a1.388,1.388,0,1,0-1.386-1.386,1.389,1.389,0,0,0,1.386,1.386",
    transform: "translate(139.876 103.077)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M69.494,56.691A1.388,1.388,0,1,0,68.108,55.3a1.389,1.389,0,0,0,1.386,1.386",
    transform: "translate(139.876 110.727)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "M70.614,57.657a3.052,3.052,0,1,0-3.051-3.051,3.056,3.056,0,0,0,3.051,3.051",
    transform: "translate(138.757 105.876)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M68.458,46.983a.319.319,0,1,1,.638,0V70.2a.319.319,0,1,1-.638,0Z",
    transform: "translate(140.595 95.831)",
    fill: "#fff",
    fillRule: "evenodd"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlImg1);
export default __webpack_public_path__ + "static/media/girl-img1.1b599e4d24e6bf4d0f36b1ee560741d6.svg";
export { ForwardRef as ReactComponent };